<template>
    <rkm-modal
        :buttons="['cancel']"
        large
        ref="Modal"
        title="Detalhes"
    >
        <rkm-table
            :fields="fields"
            :items="items"
            hide-filters
            hide-pagination
            thead-class="d-none"
        />
    </rkm-modal>
</template>

<script>
export default {
    computed: {
        fields() {

            return [
                {
                    key: "field",
                    class: "font-weight-bold col-min",
                },
                {
                    key: "value",
                },
            ]
        },
    },
    data: () => ({
        acompanhamentoOci: null,
        items: [],
    }),
    methods: {
        open(item) {

            this.acompanhamentoOci = item

            this.items = [
                {
                    field: 'Paciente',
                    value: item.pacienteNome,
                },
                {
                    field: 'Data de nascimento',
                    value: item.pacienteDataNascimento,
                },
                {
                    field: 'Idade',
                    value: item.pacienteIdade,
                },
                {
                    field: 'Sexo',
                    value: item.pacienteSexoDescricao,
                },
                {
                    field: 'Data do protocolo',
                    value: item.data,
                },
                {
                    field: 'Profissional responsável',
                    value: item.usuarioResponsavelNome,
                },
                {
                    field: 'Unidade executora',
                    value: item.unidadeExecutoraNomeFantasia,
                },
                {
                    field: 'Linha de cuidado',
                    value: item.linhaCuidado,
                },
                {
                    field: 'CID',
                    value: item.cids.join(', '),
                },
                {
                    field: 'Etapa clínica atual',
                    value: item.etapaClinicaAtualNome,
                },
                {
                    field: 'Tempo em andamento',
                    value: `${item.tempoDias} dia(s)`,
                },
            ]

            this.$refs.Modal.show()
        },
    },
}
</script>